import classNames from 'classnames'
import htmlReactParser from 'html-react-parser'
import React from 'react'
import Card from 'react-bootstrap/Card'
import reactStringReplace from 'react-string-replace'
import YouTube from 'react-youtube'

import styles from './Description.module.scss'

type Props = {
  children: string
}

const Description = ({ children }: Props) => {
  if (!children) return null

  // Replace YouTube links with embedded videos
  const newChildren = reactStringReplace(children, /https:\/\/www.youtube.com\/watch\?v=/, (match) => (
    <YouTube videoId={match} />
  ))

  return (
    <Card className={classNames(styles.description, 'shadow-sm')}>
      <Card.Body>
        {newChildren?.map((child) =>
          React.isValidElement(child) ? child : child ? htmlReactParser(child as string) : null,
        )}
      </Card.Body>
    </Card>
  )
}

export default Description
